import React, { useState, useEffect } from "react";
import axios from "axios";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Carousel from "./Carousel";

export default function LandingSliders() {
  const API_BASE = "https://laravel-api.aj-mart.com/api";
  const [landingBanners, setLandingBanners] = useState([]);
  const [extraBanners, setExtraBanners] = useState([]);

  // جلب البيانات من API
  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${API_BASE}/banners`);
      if (response.data.banners) {
        // فصل الصور الأساسية (للسلايدر)
        const landingImages = response.data.banners
          .filter((banner) => banner.banner_landing_image)
          .map((banner) => ({
            id: `${banner.id}-landing`,
            image: `https://aj-mart.com/storage/app/public/${banner.banner_landing_image}`,
          }));
        setLandingBanners(landingImages);

        // فصل الصور الإضافية (للقسم بجانب السلايدر)
        const extraImages = response.data.banners.reduce((acc, banner) => {
          const images = [];
          if (banner.banner_extra_image1) {
            images.push({
              id: `${banner.id}-extra1`,
              image: `https://laravel-api.aj-mart.com/storage/app/public/${banner.banner_extra_image1}`,
            });
          }
          if (banner.banner_extra_image2) {
            images.push({
              id: `${banner.id}-extra2`,
              image: `https://laravel-api.aj-mart.com/storage/app/public/${banner.banner_extra_image2}`,
            });
          }
          return [...acc, ...images];
        }, []);
        setExtraBanners(extraImages.slice(0, 2)); // عرض صورتين فقط لتتناسب مع التصميم
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // إعداد رأس التوثيق إذا لزم الأمر
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);

  return (
    <section className="hv-25 direction-ar w-full h-[50vh] flex border-b-[5px] border-[#1485a6]">
      <div className="  w-[100%] md:w-[50%]  h-full overflow-hidden">
        <Carousel banners={landingBanners} />
      </div>
      <div className="w-[50%] h-full  flex-col md:flex hidden">
        {extraBanners.length > 0 ? (
          extraBanners.map((banner) => (
            <div key={banner.id}>
              <img className="w-full h-[24.8vh]" src={banner.image} alt="" />
            </div>
          ))
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-500">
            No extra banners available
          </div>
        )}
      </div>
    </section>
  );
}